import ptBr from 'date-fns/locale/pt-BR';
import React, { useEffect, useState } from 'react';
import { registerLocale } from 'react-datepicker';
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

const CustomizedAxisTick = (props) => {
  const { x, y, payload } = props;

  const formatDate = React.useCallback((date) => {
    return date.substring(0, 5);
  }, []);

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        fontSize={10}
        x={0}
        y={0}
        dy={16}
        textAnchor="end"
        fill="#667"
        transform="rotate(-35)"
      >
        {formatDate(payload.value)}
      </text>
    </g>
  );
};
const GraficoLine = React.forwardRef((props, ref) => {
  registerLocale('pt-BR', ptBr);
  const { lista } = props;

  const [listaGrafico, setListaGrafico] = useState(null);

  const getValorFormat = (valor) =>
    `R$ ${valor.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

  const getMonth = React.useCallback((date) => {
    const [, m] = date?.split('-');
    return m;
  }, []);

  const formateDate = React.useCallback((date) => {
    const [y, m, d] = date?.split('-');
    return `${d}/${m}/${y}`;
  }, []);

  const getParentWidth = React.useCallback((element) => {
    if (!element) return 600;
    return element - 16;
  }, []);

  useEffect(() => {
    const diaMes = lista?.lancamentos?.map((item) => ({
      dia: formateDate(item.data),
      Receita: item.valorTotalReceita,
      Despesa: item.valorTotalDespesa,
    }));
    setListaGrafico(diaMes);
  }, [formateDate, getMonth, lista]);

  return (
    <div style={{ padding: '24px 8px' }}>
      <LineChart
        width={getParentWidth(ref?.current?.offsetWidth)}
        height={400}
        data={listaGrafico}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <XAxis
          dataKey="dia"
          minTickGap={8}
          height={60}
          tick={<CustomizedAxisTick />}
        />
        <YAxis
          tick={{ fontSize: 12, width: 100 }}
          tickFormatter={getValorFormat}
          axisLine={false}
          tickLine={false}
          tickCount={7}
        />
        <CartesianGrid vertical={false} />
        <Tooltip formatter={getValorFormat} />
        <Legend />
        <Line
          type="monotone"
          dataKey="Receita"
          stroke="#53B722"
          isAnimationActive={true}
          dot={{ stroke: 'black', strokeWidth: 1 }}
          activeDot={{ r: 8 }}
        />
        <Line
          type="monotone"
          dataKey="Despesa"
          stroke="#C13642"
          isAnimationActive={true}
          dot={{ stroke: 'black', strokeWidth: 1 }}
          activeDot={{ r: 4 }}
        />
      </LineChart>
    </div>
  );
});

export default GraficoLine;
